export default __webpack_public_path__ + "static/media/parasiticsoulswarm.dd305092.png";